// extracted by mini-css-extract-plugin
export default {"crumb":"Breadcrumbs_crumb__lYkwI","custom_hover":"Breadcrumbs_custom_hover__lRPJq"};